import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000
});

// 响应拦截器
api.interceptors.response.use(
  response => response.data,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// 新闻API
export const newsAPI = {
  getList: (params) => api.get('/news', { params }),
  getOne: (id) => api.get(`/news/${id}`)
};

// 白皮书API
export const whitepaperAPI = {
  getList: () => api.get('/whitepapers'),
  getDownloadUrl: (id) => `${API_BASE_URL}/whitepapers/download/${id}`
};

// 预约API
export const contactAPI = {
  submit: (data) => api.post('/contacts', data)
};

export default api;